import { loadScript } from "./utils";
import ApiService from "./api_service";

export default class DragulaModule {
  constructor(controller) {
    this.controller = controller;
    this.drake = null;
    this.isDragging = false;
    this.dragulaScriptUrl =
      "https://cdnjs.cloudflare.com/ajax/libs/dragula/3.7.3/dragula.min.js";
    this.apiService = new ApiService();
  }

  initialize() {
    if (!this.controller.hasIntegrantesColumnTarget) return;
    if (window.innerWidth <= 800) return;

    this.loadDragulaScript()
      .then(() => this.initDragula())
      .catch((error) => console.error("Erro ao carregar Dragula:", error));
  }

  destroy() {
    if (this.drake) {
      this.drake.destroy();
      this.drake = null;
    }
  }

  async loadDragulaScript() {
    try {
      await loadScript(this.dragulaScriptUrl);
    } catch (error) {
      console.error("Erro ao carregar o script Dragula:", error);
      throw error;
    }
  }

  initDragula() {
    // Configuração do Dragula (usando a versão CDN)
    if (typeof dragula !== "undefined") {
      // Coletar todos os containers de funções de todos os kanbanBoards
      const funcaoContainers = [];
      this.controller.kanbanBoardTargets.forEach((board) => {
        const containers = Array.from(
          board.querySelectorAll(".funcao-container")
        );
        funcaoContainers.push(...containers);
      });

      this.drake = dragula(
        [this.controller.integrantesColumnTarget, ...funcaoContainers],
        {
          // Configurações do Dragula
          copy: (el, source) => {
            // Copia o elemento quando arrastado da coluna de integrantes
            return source === this.controller.integrantesColumnTarget;
          },
          accepts: (el, target, source, sibling) => {
            // Não aceita soltar na coluna de integrantes
            return target !== this.controller.integrantesColumnTarget;
          },
          removeOnSpill: true, // Remove o elemento se for solto fora de um container
          revertOnSpill: true, // Reverte a posição se for solto fora de um container
        }
      );

      // Eventos do Dragula
      this.drake.on("drag", () => {
        this.isDragging = true;
        this.controller.isDragging = true;
      });

      this.drake.on("dragend", () => {
        // Definir um pequeno atraso antes de permitir reinicializações novamente
        setTimeout(() => {
          this.isDragging = false;
          this.controller.isDragging = false;
        }, 500);
      });

      this.drake.on("drop", (el, target, source, sibling) => {
        if (target) {
          const scaleId = target.dataset.scaleId;
          const sourceRoleId = source.dataset.role;
          const roleId = target.dataset.role;
          const memberId = el.dataset.memberId;

          if (sourceRoleId) {
            this.apiService.updateMember({
              id: el.dataset.memberScaleId,
              ministryScaleId: scaleId,
              memberId: memberId,
              roleId: roleId,
            });
          } else {
            this.apiService
              .createMember({
                ministryScaleId: scaleId,
                memberId: memberId,
                roleId: roleId,
              })
              .then((response) => {
                el.dataset.memberScaleId = response.id;
                this.createDeleteButton(el);
              });
          }
        }
      });

      this.drake.on("remove", (el, container, source) => {
        if (el.dataset.memberScaleId) {
          const memberScaleId = el.dataset.memberScaleId;
          this.apiService.deleteMember(memberScaleId);
        }
      });
    } else {
      console.error(
        "Dragula não está disponível. Verifique se o script foi carregado corretamente."
      );
    }
  }

  createDeleteButton(el) {
    const button = document.createElement("button");
    button.setAttribute(
      "class",
      "text-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300 cursor-pointer"
    );
    button.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    `;
    button.addEventListener("click", () => {
      if (el.dataset.memberScaleId) {
        if (confirm("Tem certeza que deseja remover este integrante?")) {
          this.apiService.deleteMember(el.dataset.memberScaleId).then(() => {
            el.closest("li").remove();
          });
        }
      }
    });

    el.querySelector("div").appendChild(button);
  }
}
